module.exports = __webpack_public_path__ + "media/smartphone.a61af189.mp3";